import { Commit } from 'vuex';

export default {
  user({ commit }: { commit: Commit }, payload: {[p: string]: any}): void {
    commit('user', payload);
  },
};
